
// GOLD

export const GOLD_PACKAGE = {
    PRICE: 325,
    NUMBER_OF_GROUPS: 25,
    NUMBER_OF_COACHES: 15,
};

// SILVER
export const SILVER_PACKAGE = {
    PRICE: 165,
    NUMBER_OF_GROUPS: 10,
    NUMBER_OF_COACHES: 5,
};

// BRONZE
export const BRONZE_PACKAGE = {
    PRICE: 125,
    NUMBER_OF_GROUPS: 5,
    NUMBER_OF_COACHES: 1,
};



